'use strict';

import { CoreRepository } from '../CoreRepository';
import { UserIntegrationOAuth } from '../../Entities/User/UserIntegrationOAuth';
import { UserIntegrationOAuthCollection } from '../../Collections/User/UserIntegrationOAuthCollection';
import { CalendarEventCollection } from '../../Collections/CalendarEventCollection';
import { ProviderCalendarEvent } from '../../Entities/External/ProviderCalendarEvent';

export class UserIntegrationOAuthRepository extends CoreRepository {
  public getUserIntegrationOAuth(userId: number, appName: string, options: object = {}) {
    return this.webAPI.getUserIntegrationOAuth(userId, appName, options).then((response) => {
      const userIntegrationOAuth = new UserIntegrationOAuth();
      userIntegrationOAuth.hydrate(response);

      return userIntegrationOAuth;
    });
  }

  public deauthorizeUserIntegrationOAuth(userId: number, appName: string, options: object = {}) {
    return this.webAPI
      .deauthorizeUserIntegrationOAuth(userId, appName, options)
      .then((response) => {
        return response;
      });
  }

  //
  public getUserIntegrationsOAuth(userId: number) {
    return this.webAPI.getUserIntegrationsOAuth(userId).then((response) => {
      const collection = new UserIntegrationOAuthCollection();

      response.data.forEach((collectionItemData) => {
        const collectionItem = new UserIntegrationOAuth();
        collectionItem.hydrate(collectionItemData);

        collection.addItem(collectionItem);
      });

      collection.setOffset(response.offset);
      collection.setLimit(response.limit);
      collection.setTotal(response.total);

      return collection;
    });
  }

  public putUserIntegrationOAuth(
    userId: number,
    appName: string,
    options: object = {},
    payload: object = {}
  ) {
    return this.webAPI
      .putUserIntegrationOAuth(userId, appName, options, payload)
      .then((response) => {
        const userIntegrationOAuth = new UserIntegrationOAuth();
        userIntegrationOAuth.hydrate(response);

        return userIntegrationOAuth;
      });
  }

  public getUserIntegrationOAuthCalendarEvents(
    userId: number,
    providerReference: string,
    calendarId: string = null,
    params: any = {}
  ) {
    return this.webAPI
      .getUserIntegrationOAuthCalendarEvents(userId, providerReference, calendarId, params)
      .then((response) => {
        const collection = new CalendarEventCollection();

        response.data.forEach((collectionItemData) => {
          const collectionItem = new ProviderCalendarEvent();
          collectionItem.hydrate(collectionItemData);

          collection.addItem(collectionItem);
        });

        collection.setOffset(response.offset);
        collection.setLimit(response.limit);
        collection.setTotal(response.total);

        return collection;
      });
  }

  public updateUserIntegrationOAuthCalendarEvent(
    userId: number,
    providerReference: string,
    eventId: string,
    payload: any
  ) {
    return this.webAPI
      .updateUserIntegrationOAuthCalendarEvent(userId, providerReference, eventId, payload)
      .then((response) => {
        const calendarEventExternal = new ProviderCalendarEvent();
        calendarEventExternal.hydrate(response);

        return calendarEventExternal;
      });
  }

  public deleteUserIntegrationOAuthCalendarEvent(
    userId: number,
    providerReference: string,
    eventId: string
  ) {
    return this.webAPI
      .deleteUserIntegrationOAuthCalendarEvent(userId, providerReference, eventId)
      .then((response) => {
        return response;
      });
  }

  public createUserIntegrationOAuthCalendarEvent(
    userId: number,
    providerReference: string,
    payload: any
  ) {
    return this.webAPI
      .createUserIntegrationOAuthCalendarEvent(userId, providerReference, payload)
      .then((response) => {
        const calendarEventExternal = new ProviderCalendarEvent();
        calendarEventExternal.hydrate(response);

        return calendarEventExternal;
      });
  }
}
